import { Component, ElementRef, ViewChild } from "@angular/core";
import { DialogBaseComponent, DialogParams } from "app/shared/dialog-base.component";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DomainService } from "app/shared/domain.service";
import { UtilFns } from "app/shared/util-fns";

export interface AddonBinSetPriorityDialogParams extends DialogParams {
  binCount: number;
}

@Component({
  templateUrl: "./addon-bin-set-priority-dialog.component.html",
  standalone: false,
})
export class AddonBinSetPriorityDialogComponent extends DialogBaseComponent<AddonBinSetPriorityDialogParams> {
  priorityOrder: number | null = null;
  binCount = 0;

  @ViewChild("priorityInput") priorityInput: ElementRef<HTMLInputElement>;

  constructor(
    public config: DynamicDialogConfig<AddonBinSetPriorityDialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService
  ) {
    super(config, dialogRef, domainService);

    Object.assign(this.config, {
      header: "Set Priority Order",
      width: "400px",
      height: "auto",
    });

    this.binCount = this.params.binCount;
    this.isPageReady = true;
    this.focusInput();
  }

  async focusInput() {
    await UtilFns.wait(1);
    this.priorityInput?.nativeElement?.focus();
  }

  ok() {
    if (!this.priorityOrder || this.priorityOrder <= 0) {
      this.dialogService.showOkMessage("Invalid Priority", "Priority must be a number greater than 0.");
      return;
    }
    this.dialogRef.close(this.priorityOrder);
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
